export const camelToSnake = (str: string): string => {
  let result = str;
  result = str.charAt(0).toLowerCase() + str.slice(1);
  result = result.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
  return result;
};

export const spaceToSnake = (str: string): string => str.replace(/[ -]/g, '_');
